import type {SupportedLocales} from '@/lib/locale/locale'

import {useFoodCart} from './useFoodCart'
import {getFoodProductQueryOptions} from './useFoodProduct'

export default function useFoodCartProductInfoQueries(locale: SupportedLocales) {
  const {data: foodCart, isLoading} = useFoodCart(locale)

  const productIds = new Set(foodCart?.foodCartItems.map(item => item.productId))

  return useQueries({
    queries: Array.from(productIds).map(productId => getFoodProductQueryOptions(productId)),
    combine: (results) => {

      const resultsMap = new Map(results.map(result => [result.data?.product_id, result.data]))

      return {
        results: {
          ...foodCart,
          foodCartItems: foodCart?.foodCartItems.map(item => {
            const details = resultsMap.get(item.productId)
            if (!details) return null
            return {
              ...item,
              details,
            }
          }).filter(Boolean) ?? []
        },
        isLoading: isLoading || results.some(result => result.isLoading),
        // isError: results.some(result => result.isError),
      }
    },
  })
}
